module.exports = __webpack_public_path__ + "static/media/Figtree-Regular.5f1dc601.ttf";